import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import SystemControls from './systemControls';
import StreamStatsTab from './streamStatsTabs';
import SystemStatsTab from './systemStats';
import StreamQosStats from './streamQosStats';
import WebrtcSender from './webrtcSender';
import PictureApiTest from './pictureApiTest';
import AutoTest from './autoTest';
import VstLogs from './vstLogs';
import RecordEvent from './recordEvent';
import AddRtspUrls from './addRtspUrls';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" hidden={value !== index}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function DebugTabs() {
  const [value, setValue] = useState(0);
  const showDebugTag = useSelector((state) => state.app.showDebugOptions);
  useEffect(() => {
    setTimeout(() => {
      setValue(0);
    }, 200);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="System controls" {...a11yProps(0)} />
          <Tab label="Stream stats" {...a11yProps(1)} />
          <Tab label="RTSP stream QOS" {...a11yProps(2)} />
          <Tab label="System stats" {...a11yProps(3)} />
          <Tab label="Add streams" {...a11yProps(4)} />
          {showDebugTag && <Tab label="Webrtc sender" {...a11yProps(5)} />}
          {showDebugTag && <Tab label="Capture Picture Test" {...a11yProps(6)} />}
          {showDebugTag && <Tab label="Auto Test" {...a11yProps(7)} />}
          {showDebugTag && <Tab label="Logs" {...a11yProps(8)} />}
          {showDebugTag && <Tab label="Event Recording" {...a11yProps(9)} />}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <SystemControls />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <StreamStatsTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <StreamQosStats />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <SystemStatsTab />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <AddRtspUrls />
      </TabPanel>
      {showDebugTag && (
        <TabPanel value={value} index={5}>
          <WebrtcSender />
        </TabPanel>
      )}
      {showDebugTag && (
        <TabPanel value={value} index={6}>
          <PictureApiTest />
        </TabPanel>
      )}
      {showDebugTag && (
        <TabPanel value={value} index={7}>
          <AutoTest />
        </TabPanel>
      )}
      {showDebugTag && (
        <TabPanel value={value} index={8}>
          <VstLogs />
        </TabPanel>
      )}
      {showDebugTag && (
        <TabPanel value={value} index={9}>
          <RecordEvent />
        </TabPanel>
      )}
    </Box>
  );
}
